import { catchException } from './plugins/bugsnag';
import { i18n } from './plugins/i18next';

const cannotInThePast = 'cannot be in the past';
const cannotBeChanged = 'cannot be changed on a already made billing';
const cannotChangeBillingPeriods = 'Billing periods execution order cannot be changed';
const mustBeBefore = 'must be before';

export function findErrors(el, massage) {
  if (massage[el]) {
    return Object.values(massage[el]);
  }
  if (massage.children) {
    return massage.children.flatMap((a) => (a[el] ? Object.values(a[el]) : findErrors(el, a)));
  }
  return massage.flatMap((el) => findErrors('constraints', el));
}

function getErrorsMap(message, property) {
  if (message.children && message.children.length) {
    return message.children.flatMap((el) => getErrorsMap(el, message.property));
  }

  if (message.constraints) {
    return {
      property: property,
      errorField: message.property,
      errorMessage: Object.values(message.constraints)[0],
    };
  }

  return message.flatMap((el) => getErrorsMap(el));
}

export const getErrorObject = (e = {}) => {
  if (e.response && e.response.status && e.response.status >= 500) {
    catchException(e);
    return {
      property: '',
      errorField: '',
      errorMessage: i18n.t('@form/somethingWentWrong'),
    };
  }

  if (
    e.response &&
    typeof e.response.data.message === 'object' &&
    !Array.isArray(e.response.data.message)
  ) {
    return getErrorsMap(e.response.data.message)[0];
  }

  let errorMessage =
    (e.response && e.response.data && (e.response.data.message || e.response.data.error)) ||
    e.message ||
    i18n.t('@form/unknownError');

  if (Array.isArray(errorMessage)) {
    errorMessage = errorMessage[0];
  }

  return { property: '', errorField: '', errorMessage };
};

export const getErrorMessage = (e = {}) => {
  if (e.response && e.response.status && e.response.status >= 500) {
    catchException(e);
    return i18n.t('@form/somethingWentWrong');
  }

  if (e.response && typeof e.response.data.message === 'object') {
    return findErrors('constraints', e.response.data.message).join(', ');
  }

  const errorMessage =
    (e.response && e.response.data && (e.response.data.message || e.response.data.error)) ||
    e.message ||
    i18n.t('@form/unknownError');

  if (errorMessage.includes(cannotInThePast)) {
    return errorMessage.replace(cannotInThePast, i18n.t('@form/cannotInThePast'));
  }

  if (errorMessage.includes(cannotBeChanged)) {
    return errorMessage.replace(cannotBeChanged, i18n.t('@form/cannotBeChanged'));
  }
  if (errorMessage.includes(cannotChangeBillingPeriods)) {
    return errorMessage.replace(
      cannotChangeBillingPeriods,
      i18n.t('@form/cannotChangeBillingPeriods'),
    );
  }
  if (errorMessage.includes(mustBeBefore)) {
    return errorMessage.replace(mustBeBefore, i18n.t('@form/mustBeBefore'));
  }
  return errorMessage;
};

export function validationError(errorField, field) {
  if (errorField === field) {
    return i18n.t('@form/invalidField');
  }
  return '';
}
